export default {
    hasAccessPermission(_authorizations, _functionalityId, _actionId) {
        var hasAccess = false;
        _authorizations.map(function (_authorization) {
            if (_authorization.functionality_id == _functionalityId && _authorization.action_id == _actionId) {
                hasAccess = true;
            }
        });
        return hasAccess;
    },
    printWithoutScreen(_idSource) {
        document.getElementById('app').style = 'display: none';
        document.getElementById('printWithoutScreen').style = 'display: block';

        var sourceEl = document.getElementById(_idSource);

        var cloneEl = sourceEl.cloneNode(true);

        var tables = cloneEl.getElementsByClassName("md-table");
        var table;

        for (var i = 0; i < tables.length; i++) {
            table = tables[i];

            table.classList.remove("md-content");

            table.children[0].classList.remove("md-table-content");
            table.children[0].classList.remove("md-scrollbar");
            table.children[0].style = 'width: 100%';
        }

        document.getElementById('printWithoutScreen').appendChild(cloneEl);

        window.print();

        document.getElementById('printWithoutScreen').innerHTML = "";
        document.getElementById('app').style = 'display: block';
        document.getElementById('printWithoutScreen').style = 'display: none';
    }
};